import posthog, { type PostHogConfig } from "posthog-js";
import { isEmbeddedSurface } from "@/lib/embedded-surface";

const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

// Known noise we never want forwarded to PostHog's exception capture:
// - "lock stolen" / "robado por otra solicitud": Safari/iOS navigator.locks
//   churn in GoTrueJS (Supabase Auth).
// - "signal is aborted without reason": same lock subsystem on Chromium.
// GoTrueJS handles both internally; the browser still surfaces them as
// uncaught rejections. Filtering them keeps the error stream signal-rich.
const NOISE_RE = /lock.*stolen|robado por otra solicitud|signal is aborted without reason/i;

export const EMBEDDED_POSTHOG_CONFIG: Partial<PostHogConfig> = {
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  capture_heatmaps: false,
  capture_dead_clicks: false,
  disable_session_recording: true,
  disable_surveys: true,
  persistence: "memory",
};

if (key) {
  try {
    posthog.init(key, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: true,
      capture_exceptions: true,
      before_send: (event) => {
        if (event && event.event === "$exception") {
          const list = (event.properties?.$exception_list ?? []) as Array<{ value?: string }>;
          const message = list[0]?.value || event.properties?.$exception_message || "";
          if (NOISE_RE.test(String(message))) return null;
        }
        return event;
      },
      ...(isEmbeddedSurface() ? EMBEDDED_POSTHOG_CONFIG : {}),
    });
  } catch {}
}

export default posthog;
